import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider, Helmet } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import AvailableHomes from "./pages/AvailableHomes";
import BuildOnYourLot from "./pages/BuildOnYourLot";
import Gallery from "./pages/Gallery";
import WhoWeAre from "./pages/WhoWeAre";
import Contact from "./pages/Contact";
import VirtualTours from "./pages/VirtualTours";
import Testimonials from "./pages/Testimonials";
import Partners from "./pages/Partners";
import Remodel from "./pages/Remodel";
import AccessibilityStatement from "./pages/AccessibilityStatement";
import AccessibilityWidget from "./components/AccessibilityWidget";
import { Toaster } from "./components/ui/toaster";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) { el.scrollIntoView({ behavior: "smooth" }); return; }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

const businessJsonLd = {
  "@context": "https://schema.org",
  "@type": "GeneralContractor",
  "@id": "https://www.monarchhomesofbrevard.com/#business",
  "name": "Monarch Homes of Brevard",
  "description": "Family-owned custom home builder on Florida's Space Coast, building beautiful, energy-efficient custom homes across Brevard County for over 40 years.",
  "url": "https://www.monarchhomesofbrevard.com",
  "telephone": "+1-321-777-2701",
  "email": "info@monarchhomesofbrevard.com",
  "foundingDate": "1980",
  "image": "https://www.monarchhomesofbrevard.com/images/new/n-3.jpg",
  "logo": "https://www.monarchhomesofbrevard.com/images/site/logo.jpg",
  "priceRange": "$$$",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "1275 South Patrick Dr, Ste K",
    "addressLocality": "Satellite Beach",
    "addressRegion": "FL",
    "postalCode": "32937",
    "addressCountry": "US"
  },
  "geo": { "@type": "GeoCoordinates", "latitude": 28.1761, "longitude": -80.5901 },
  "openingHoursSpecification": [{
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    "opens": "10:00", "closes": "17:00"
  }],
  "areaServed": [
    { "@type": "AdministrativeArea", "name": "Brevard County, Florida" },
    { "@type": "City", "name": "Melbourne Beach, Florida" },
    { "@type": "City", "name": "Indialantic, Florida" },
    { "@type": "City", "name": "Indian Harbour Beach, Florida" },
    { "@type": "City", "name": "Satellite Beach, Florida" },
    { "@type": "City", "name": "Viera, Florida" },
    { "@type": "City", "name": "Melbourne, Florida" }
  ],
  "knowsAbout": [
    "Custom Home Builder Brevard County",
    "Melbourne Beach Custom Home Builder",
    "Indialantic Custom Home Builder",
    "Indian Harbour Beach Custom Home Builder",
    "Satellite Beach Custom Home Builder",
    "Viera Custom Home Builder"
  ],
  "sameAs": [
    "https://www.facebook.com/",
    "https://www.instagram.com/"
  ]
};

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(businessJsonLd)}</script>
      </Helmet>
      <BrowserRouter>
        <ScrollToTop />
        <div className="mh-app-content">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/available-homes" element={<AvailableHomes />} />
              <Route path="/build-on-your-lot" element={<BuildOnYourLot />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/who-we-are" element={<WhoWeAre />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/virtual-tours" element={<VirtualTours />} />
              <Route path="/testimonials" element={<Testimonials />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/remodel" element={<Remodel />} />
              <Route path="/accessibility-statement" element={<AccessibilityStatement />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <AccessibilityWidget />
        <Toaster />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
